var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"emailBuilderContainer"}},[_c(_vm.targetBuilder,{tag:"component",attrs:{"email-template-id":this.$route.params.id,"preview-mode":_vm.setPreviewMode(this.$route.query.previewMode),"header-title":"Edit Email Template"},on:{"load-failure":_vm.showLoadError,"save":_vm.handleSave}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }